import React, {useEffect, useState} from 'react';
import {Form} from 'react-bootstrap';
import {getSogEnvList} from '../common';

export default function SelectSoGEnvComponent(): JSX.Element {
    const [env, setEnv] = useState('');

    const handleEnvSelect = (eventKey: string | null) => {
        localStorage.setItem('sog_env', eventKey || '0');
        setEnv(eventKey || "0");
    };

    useEffect(() => {
        setEnv(getSogEnvList()[Number(localStorage.getItem('sog_env') || '0')]);
    }, []);

    return (
        <Form.Select
            aria-label="Select blockchain"
            value={env}
            className="text-capitalize w-100"
            style={{cursor: "pointer"}}
            onChange={(e) => {
                handleEnvSelect(e.target.value)
            }}
        >
            {
                getSogEnvList()?.map((e, i) => {
                    return (
                        <option key={i} className="w-100" value={i.toString()}>{e}</option>
                    );
                })
            }
        </Form.Select>
    );
}
